'use client';
import type { ComponentProps } from 'react';
import { CountryCurrency, getCartSummary, getFilteredHalloweenPromoItems, useCartService } from '@skin-seoul/service';
import { LegacyCartIcon } from '../../assets/LegacyCartIcon';
import QueryBoundary from '../../utils/react/QueryBoundary';
import type { Country } from '@skin-seoul/service';
import { ClientOnly } from '@skin-seoul/utils';

const SHOPPING_BAG_BUTTON_TEST_ID = 'shopping-bag-button';

const ProductQuantity = ({ country }: { country: Country }) => {
  const { useGetCartSuspenseQuery } = useCartService();
  const { data } = useGetCartSuspenseQuery({ currency: CountryCurrency[country] });
  const { items } = getCartSummary(data.cart);
  const filteredItems = getFilteredHalloweenPromoItems(items);
  const totalQuantity = filteredItems.reduce((prev, curr) => prev + curr.quantity, 0);

  return <span className="text-label-small text-generic-0">{totalQuantity}</span>;
};

type ShoppingBagButtonProps = {
  country: Country;
  iconProps?: ComponentProps<typeof LegacyCartIcon>;
  className?: string;
  onClick?: () => void;
};

const ShoppingBagButton = ({
  country,
  iconProps = { color: 'generic.0' },
  className,
  onClick,
}: ShoppingBagButtonProps) => {
  return (
    <div
      className={`cursor-pointer w-fit h-fit relative ${className || ''}`}
      data-testid={SHOPPING_BAG_BUTTON_TEST_ID}
      onClick={onClick}
    >
      <LegacyCartIcon cursor="pointer" height="24px" width="24px" {...iconProps} />
      <ClientOnly>
        <div className="flex items-center bg-[#027A48] rounded-[14px] text-label-small h-4 justify-center absolute -right-1 -top-1 w-4">
          <QueryBoundary
            loadingFallback={<span className="text-label-small text-generic-0">0</span>}
            errorFallback={<span className="text-label-small text-generic-0">0</span>}
          >
            <ProductQuantity country={country} />
          </QueryBoundary>
        </div>
      </ClientOnly>
    </div>
  );
};

export default ShoppingBagButton;
